import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import ids from 'Components/Worksheets/QestIds';
import { ResultsSection, WashingSection } from './Sections';

const qestIds = [ids.wash.AS_1141_11_1.rev2020];

let As1141_11_1_MeasuredWashSievingWorksheet: WorksheetRootComponent = () => (
  <>
    <WashingSection />
    <ResultsSection />
  </>
);

As1141_11_1_MeasuredWashSievingWorksheet.qestIds = qestIds;
As1141_11_1_MeasuredWashSievingWorksheet = withInjectedProps(As1141_11_1_MeasuredWashSievingWorksheet);

export default As1141_11_1_MeasuredWashSievingWorksheet;
export { As1141_11_1_MeasuredWashSievingWorksheet };
